export interface NavigationItem {
  id: string;
  title: React.ReactNode;
  url: string;
  icon: React.ReactNode;
  disabled?: boolean;
}

interface NavigationGroupItem {
  id: string;
  title: React.ReactNode;
  items: NavigationItem[];
}

export type NavigationGroups = (NavigationGroupItem | NavigationItem)[];

export function isNavigationItem(item: NavigationItem | NavigationGroupItem): item is NavigationItem {
  return 'url' in item && !('items' in item);
}
